import { downloadFile, generateBlob } from '@chilecompra/react-kit'
import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { getUnitsMeasure } from '../../services/config'
import { getRegionCached } from '../../services/config.cached'
import { deleteFile, getAttachedFiles, getDowloadFile, uploadFile } from '../../services/files'
import { saveRoughCopy } from '../../services/quote'
import { getFragmentationAlert } from '../../services/products'

export const UPDATE_GUEST = 'UPDATE_GUEST'
export const UPDATE_GUEST_SUCCESS = 'UPDATE_GUEST_SUCCESS'
export const onUpdateGuestSuccess = makeActionCreator(UPDATE_GUEST_SUCCESS, 'payload')
export const onUpdateGuest = payload => dispatch =>
  batch(() => {
    dispatch(onHideGuestFormSuccess())
    dispatch(onUpdateGuestSuccess(payload))
  })

export const HIDE_GUEST_FORM_SUCCESS = 'HIDE_GUEST_FORM_SUCCESS'
export const SHOW_GUEST_FORM_SUCCESS = 'SHOW_GUEST_FORM_SUCCESS'
export const onHideGuestFormSuccess = makeActionCreator(HIDE_GUEST_FORM_SUCCESS)
export const onShowGuestFormSuccess = makeActionCreator(SHOW_GUEST_FORM_SUCCESS)

export const GET_UNITS_MEASURE = 'GET_UNITS_MEASURE'
export const GET_UNITS_MEASURE_ERROR = 'GET_UNITS_MEASURE_ERROR'
export const GET_UNITS_MEASURE_SUCCESS = 'GET_UNITS_MEASURE_SUCCESS'
export const onGetUnitsMeasure = makeActionCreator(GET_UNITS_MEASURE)
export const onGetUnitsMeasureError = makeActionCreator(GET_UNITS_MEASURE_ERROR, 'payload')
export const onGetUnitsMeasureSuccess = makeActionCreator(GET_UNITS_MEASURE_SUCCESS, 'payload')

export const onGetUnitsMeasureThunk = () => async dispatch => {
  dispatch(onGetUnitsMeasure())

  try {
    const { data } = await getUnitsMeasure()

    const unitsMeasure = data.payload?.unidades?.map(units => ({
      name: units.nombre.toUpperCase(),
      value: units.id
    }))

    unitsMeasure.sort(function (a, b) {
      if (a.name > b.name) return 1
      if (a.name < b.name) return -1
      return 0
    })

    return dispatch(onGetUnitsMeasureSuccess({ unitsMeasure }))
  } catch (error) {
    return dispatch(onGetUnitsMeasureError({ error }))
  }
}

export const GET_REGIONS = 'GET_REGIONS'
export const GET_REGIONS_SUCCESS = 'GET_REGIONS_SUCCESS'
export const GET_REGIONS_ERROR = 'GET_REGIONS_ERROR'
export const onGetRegion = makeActionCreator(GET_REGIONS)
export const onGetRegionError = makeActionCreator(GET_REGIONS_ERROR, 'payload')
export const onGetRegionSuccess = makeActionCreator(GET_REGIONS_SUCCESS, 'payload')

export const onGetRegionsThunk = () => async dispatch => {
  dispatch(onGetRegion())
  try {
    const { data } = await getRegionCached()
    const regions = data.payload?.map(region => ({ name: region.nombre, value: region.id }))

    dispatch(onGetRegionSuccess({ regions }))
  } catch (error) {
    dispatch(onGetRegionError({ error }))
  }
}

export const SAVE_ROUGH_COPY = 'SAVE_ROUGH_COPY'
export const SAVE_ROUGH_COPY_SUCCESS = 'SAVE_ROUGH_COPY_SUCCESS'
export const SAVE_ROUGH_COPY_ERROR = 'SAVE_ROUGH_COPY_ERROR'
export const onSaveRoughCopy = makeActionCreator(SAVE_ROUGH_COPY)
export const onSaveRoughCopyError = makeActionCreator(SAVE_ROUGH_COPY_ERROR, 'payload')
export const onSaveRoughCopySuccess = makeActionCreator(SAVE_ROUGH_COPY_SUCCESS, 'payload')

export const onSaveRoughCopyThunk = payload => async (dispatch, getState) => {
  dispatch(onSaveRoughCopy())

  try {
    const {
      quote: { code }
    } = getState().quoteStepOne
    const { productsSaved: products } = getState().addProductsService
    const {
      companySizeFilter = 0,
      filterRegionCode = -1,
      filterRegionNotification = 0,
      sellersAdded,
      isEnvironmental,
      isSocialEconomic
    } = getState().quoteStepTwo

    const sellersAddedDni = sellersAdded?.map(seller => seller.dni) || []

    await saveRoughCopy({
      code,
      companySizeFilter,
      filterRegionCode,
      filterRegionNotification,
      finesPenalties: payload.finesPenalties,
      products,
      sellersAddedDni,
      isEnvironmental: isEnvironmental === 'yes',
      isSocialEconomic: isSocialEconomic === 'yes'
    })

    return batch(() => {
      dispatch(onSaveRoughCopySuccess())
      payload.callback({ response: 'success' })
    })
  } catch (error) {
    const err = error?.originalError?.response?.data?.errores?.map(error => ({
      code: error.codigo,
      description: error.descripcion
    }))

    return batch(() => {
      dispatch(onSaveRoughCopyError({ error: err }))
      payload.callback({ response: 'error' })
    })
  }
}

export const UPLOAD_FILE = 'UPLOAD_FILE'
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS'
export const UPLOAD_FILE_ERROR = 'UPLOAD_FILE_ERROR'
export const onUploadFile = makeActionCreator(UPLOAD_FILE)
export const onUploadFileError = makeActionCreator(UPLOAD_FILE_ERROR, 'payload')
export const onUploadFileSuccess = makeActionCreator(UPLOAD_FILE_SUCCESS, 'payload')

export const onUploadFileThunk = payload => async dispatch => {
  dispatch(onUploadFile())
  try {
    await uploadFile(payload)
    return batch(() => {
      dispatch(onUploadFileSuccess())
      dispatch(onGetAttachedFilesThunk({ quoteCode: payload.quoteCode }))
    })
  } catch (error) {
    if (error.code === 400) {
      const err = error?.originalError?.response?.data?.errores?.map(error => ({
        code: error.codigo,
        description: error.descripcion
      }))

      return dispatch(onUploadFileError({ error: err }))
    }

    dispatch(onUploadFileError({ error }))
  }
}

export const GET_ATTACHED_FILES = 'GET_ATTACHED_FILES'
export const GET_ATTACHED_FILES_SUCCESS = 'GET_ATTACHED_FILES_SUCCESS'
export const GET_ATTACHED_FILES_ERROR = 'GET_ATTACHED_FILES_ERROR'
export const onGetAttachedFiles = makeActionCreator(GET_ATTACHED_FILES)
export const onGetAttachedFilesError = makeActionCreator(GET_ATTACHED_FILES_ERROR, 'payload')
export const onGetAttachedFilesSuccess = makeActionCreator(GET_ATTACHED_FILES_SUCCESS, 'payload')

export const onGetAttachedFilesThunk = payload => async dispatch => {
  dispatch(onGetAttachedFiles())

  try {
    const { data } = await getAttachedFiles({ quoteCode: payload.quoteCode })
    const attachedFiles = data.payload?.files?.map(attachedFile => ({
      id: attachedFile.id,
      name: attachedFile.nombreArchivo
    }))

    dispatch(onGetAttachedFilesSuccess({ attachedFiles }))
  } catch (error) {
    if (error.code === 400) {
      const err = error?.originalError?.response?.data?.errores?.map(error => ({
        code: error.codigo,
        description: error.descripcion
      }))

      return dispatch(onGetAttachedFilesError({ error: err }))
    }

    dispatch(onGetAttachedFilesError({ error: {} }))
  }
}

export const GET_DOWNLOAD_FILE = 'GET_DOWNLOAD_FILE'
export const GET_DOWNLOAD_FILE_ERROR = 'GET_DOWNLOAD_FILE_ERROR'
export const GET_DOWNLOAD_FILE_SUCCESS = 'GET_DOWNLOAD_FILE_SUCCESS'
export const onGetDownloadFile = makeActionCreator(GET_DOWNLOAD_FILE)
export const onGetDownloadFileError = makeActionCreator(GET_DOWNLOAD_FILE_ERROR, 'payload')
export const onGetDownloadFileSuccess = makeActionCreator(GET_DOWNLOAD_FILE_SUCCESS, 'payload')
export const onGetDownloadFileThunk = payload => async dispatch => {
  dispatch(onGetDownloadFile())

  try {
    const { data, headers } = await getDowloadFile({ fileId: payload.id })
    const blob = generateBlob(data, headers['content-type'])
    downloadFile(blob, payload.name)
    return dispatch(onGetDownloadFileSuccess())
  } catch (error) {
    if (error.code === 400) {
      const err = error?.originalError?.response?.data?.errores?.map(error => ({
        code: error.codigo,
        description: error.descripcion
      }))

      return dispatch(onGetDownloadFileError({ error: err }))
    }

    return dispatch(onGetDownloadFileError({ error: {} }))
  }
}

export const DELETE_FILE = 'DELETE_FILE'
export const DELETE_FILE_ERROR = 'DELETE_FILE_ERROR'
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS'
export const onDeleteFile = makeActionCreator(DELETE_FILE)
export const onDeleteFileError = makeActionCreator(DELETE_FILE_ERROR, 'payload')
export const onDeleteFileSuccess = makeActionCreator(DELETE_FILE_SUCCESS, 'payload')
export const onDeleteFileThunk = payload => async dispatch => {
  dispatch(onDeleteFile())
  const { fileId, ipUsuario, quoteCode } = payload

  try {
    await deleteFile({ fileId, ipUsuario })
    return batch(() => {
      dispatch(onDeleteFileSuccess())
      dispatch(onGetAttachedFilesThunk({ quoteCode }))
    })
  } catch (error) {
    if (error.code === 400) {
      const err = error?.originalError?.response?.data?.errores?.map(error => ({
        code: error.codigo,
        description: error.descripcion
      }))

      return dispatch(onDeleteFileError({ error: err }))
    }

    return dispatch(onDeleteFileError({ error: {} }))
  }
}

export const FRAGMENTATION_ALERT = 'FRAGMENTATION_ALERT'
export const FRAGMENTATION_ALERT_ERROR = 'FRAGMENTATION_ALERT_ERROR'
export const FRAGMENTATION_ALERT_SUCCESS = 'FRAGMENTATION_ALERT_SUCCESS'
export const onFragmentationAlert = makeActionCreator(FRAGMENTATION_ALERT)
export const onFragmentationAlertError = makeActionCreator(FRAGMENTATION_ALERT_ERROR, 'payload')
export const onFragmentationAlertSuccess = makeActionCreator(FRAGMENTATION_ALERT_SUCCESS, 'payload')
export const onFragmentationAlertThunk = payload => async dispatch => {
  dispatch(onFragmentationAlert())
  try {
    const { data } = await getFragmentationAlert(payload)
    const fragmentationAlert = data?.payload?.alertaFragmentacion

    dispatch(onFragmentationAlertSuccess({ fragmentationAlert }))
  } catch (error) {
    dispatch(onFragmentationAlertError({ error }))
  }
}

export const CLEAR_FORM_STEP_TWO = 'CLEAR_FORM_STEP_TWO'
export const onClearFormStepTwo = makeActionCreator(CLEAR_FORM_STEP_TWO)

export const CLEAR_ERRORS_STEP_TWO = 'CLEAR_ERRORS_STEP_TWO'
export const onClearErrorsStepTwo = makeActionCreator(CLEAR_ERRORS_STEP_TWO)

export const SAVE_FINES_PENALTIES_SUCCESS = 'SAVE_FINES_PENALTIES_SUCCESS'
export const onSaveFinesPenaltiesSuccess = makeActionCreator(SAVE_FINES_PENALTIES_SUCCESS, 'payload')

export const REGION_NOTIFICATION_SUCCESS = 'REGION_NOTIFICATION_SUCCESS'
export const onRegionNotificationSuccess = makeActionCreator(REGION_NOTIFICATION_SUCCESS, 'payload')

export const COMPANY_SIZE_FILTER_SUCCESS = 'COMPANY_SIZE_FILTER_SUCCESS'
export const onCompanySizeFilterSuccess = makeActionCreator(COMPANY_SIZE_FILTER_SUCCESS, 'payload')

export const GET_QUOTE_NOTIFICATIONS_SUCCESS = 'GET_QUOTE_NOTIFICATIONS_SUCCESS'
export const onGetQuoteNotificationsSuccess = makeActionCreator(GET_QUOTE_NOTIFICATIONS_SUCCESS, 'payload')

export const ADD_SELLER_SUCCESS = 'ADD_SELLER_SUCCESS'
export const onAddSellerSuccess = makeActionCreator(ADD_SELLER_SUCCESS, 'payload')

export const REMOVE_SELLER_SUCCESS = 'REMOVE_SELLER_SUCCESS'
export const onRemoveSellerSuccess = makeActionCreator(REMOVE_SELLER_SUCCESS, 'payload')

export const CLOSE_MORE_INFO_DIALOG = 'CLOSE_MORE_INFO_DIALOG'
export const onCloseMoreInfoDialog = makeActionCreator(CLOSE_MORE_INFO_DIALOG)

export const OPEN_MORE_INFO_DIALOG = 'OPEN_MORE_INFO_DIALOG'
export const onOpenMoreInfoDialog = makeActionCreator(OPEN_MORE_INFO_DIALOG)

export const SET_ENVIRONMENTAL_VALUE = 'SET_ENVIRONMENTAL_VALUE'
export const onSetEnvironmentalValue = makeActionCreator(SET_ENVIRONMENTAL_VALUE, 'payload')

export const SET_SOCIAL_ECONOMIC_VALUE = 'SET_SOCIAL_ECONOMIC_VALUE'
export const onSetSocialEconomicValue = makeActionCreator(SET_SOCIAL_ECONOMIC_VALUE, 'payload')
